import * as Types from "../../graphql/schemaTypes.generated";

import { GetBankAccountFieldsFragment } from "./BankAccountFragment.generated";
import { ActualBalancesFieldsFragment } from "./ActualBalancesFields.generated";
import gql from "graphql-tag";
import { GetBankAccountFieldsFragmentDoc } from "./BankAccountFragment.generated";
import { ActualBalancesFieldsFragmentDoc } from "./ActualBalancesFields.generated";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetBankAccountQueryVariables = Types.Exact<{
  account_id: Types.Scalars["String"];
  balancesLimit: Types.Scalars["Int"];
  balancesOffset: Types.Scalars["Int"];
}>;

export type GetBankAccountQuery = { __typename?: "query_root" } & {
  bank_accounts_by_pk?: Types.Maybe<
    { __typename?: "bank_accounts" } & {
      actual_balances: Array<
        { __typename?: "actual_balances" } & ActualBalancesFieldsFragment
      >;
    } & GetBankAccountFieldsFragment
  >;
};

export const GetBankAccountDocument = gql`
  query GetBankAccount(
    $account_id: String!
    $balancesLimit: Int!
    $balancesOffset: Int!
  ) {
    bank_accounts_by_pk(account_id: $account_id) {
      ...getBankAccountFields
      actual_balances(
        limit: $balancesLimit
        offset: $balancesOffset
        order_by: [{ date: desc }, { created_at: desc }]
      ) {
        ...actualBalancesFields
      }
    }
  }
  ${GetBankAccountFieldsFragmentDoc}
  ${ActualBalancesFieldsFragmentDoc}
`;

export function useGetBankAccountQuery(
  options: Omit<Urql.UseQueryArgs<GetBankAccountQueryVariables>, "query"> = {}
) {
  return Urql.useQuery<GetBankAccountQuery>({
    query: GetBankAccountDocument,
    ...options,
  });
}
